/**
 * RouteGuard — gate for authenticated routes.
 * Redirects to /login (preserving the attempted path) when not authenticated.
 */

import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/authStore';

interface RouteGuardProps {
  children: ReactElement;
}

export function RouteGuard({ children }: RouteGuardProps): ReactElement {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
